module.exports = __webpack_public_path__ + "static/media/ru.51e78aee.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ru.svg
// module id = 2199
// module chunks = 0